import React from 'react';
import ReactDOM from 'react-dom';
import * as labelService from '@cm/new-shared-fe/services/labels';
import * as parameterService from '@cm/new-shared-fe/services/parameters';

import { Application } from './app.component';
import { AuthProvider } from './auth.context.js';

// IIFE Just so I can get to the async function...
(async () => {
  const domains = { cm: 'nl', mc: 'fr', 'ckk-mc': 'de' };
  const language = domains[window.location.hostname.split('.').reverse()[1]] || document.documentElement.lang;
  await labelService.initialize(['EZVK2'], language, '/ezvk-app');
  await parameterService.initialize('EZVK2', language, '/ezvk-app');
  ReactDOM.render(<AuthProvider><Application/></AuthProvider>, document.querySelector('#ezvk-app'));
})();
